import { render, staticRenderFns } from "./Popular.vue?vue&type=template&id=49fd2792&scoped=true&"
import script from "./Popular.vue?vue&type=script&lang=js&"
export * from "./Popular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fd2792",
  null
  
)

export default component.exports